/**
 * @file: react-native-wechat-lib.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export async function registerApp() {}

export async function isWXAppInstalled(): Promise<boolean> {
  return false;
}

export async function sendAuthRequest() {}

export async function shareMiniProgram() {}

export async function shareLocalImage() {}

export async function shareWebpage() {}

export async function openCustomerServiceChat() {}
